import { render } from "./TestimonialsComponent.vue?vue&type=template&id=9b9a79fa&scoped=true&ts=true"
import script from "./TestimonialsComponent.vue?vue&type=script&lang=ts"
export * from "./TestimonialsComponent.vue?vue&type=script&lang=ts"

import "./TestimonialsComponent.vue?vue&type=style&index=0&id=9b9a79fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b9a79fa"]])

export default __exports__